module.exports = "https://r.zoocdn.com/_next/static/images/favicon-32x32-4f2b054ba0516cd61a4e65816fed6e5f.png";